import { render, staticRenderFns } from "./CommunitiesHot.vue?vue&type=template&id=396070e1"
import script from "./CommunitiesHot.vue?vue&type=script&lang=js"
export * from "./CommunitiesHot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports